// usePusherHold — keep the shared Pusher connection alive through hidden-tab
// idleness while `active` is true.
//
// The idle-tab disconnect (see ./pusher-connection) is a pure resource
// optimization and must never change what the user experiences. Some flows are
// DESIGNED around events reaching a hidden tab: an in-flight agent turn, the
// concierge run's away-notifications ("a designer has a question" / "matches are
// ready" — browser Notification + favicon dot, lib/notify.ts in web), and the
// export buttons awaiting their one-shot ready event. A consumer in such a wait
// declares it with this hook; while any hold is active the hidden-tab drop is
// suspended, and when the last hold releases the idle clock starts (immediately,
// if the tab is already hidden). Truly idle tabs — nothing in flight, nothing
// awaited — still release their socket.

import { useEffect } from "react";

import { acquireVisibilityHold } from "./pusher-connection";
import type { PusherChannelConfig } from "./usePusherChannel";

export function usePusherHold(config: PusherChannelConfig, active: boolean): void {
  const headersKey = JSON.stringify(config.authHeaders ?? {});
  useEffect(() => {
    if (!active) return;
    // acquire returns its release fn — exactly the effect cleanup.
    return acquireVisibilityHold(config);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    active,
    config.key,
    config.host,
    config.port,
    config.useTls,
    config.cluster,
    config.authEndpoint,
    config.idleDisconnectMs,
    headersKey,
  ]);
}
